import { Crown } from "lucide-react";

/**
 * Gründungsmitglied-Badge — permanent sichtbare Auszeichnung für die ersten
 * 50 approvten Mitglieder. Nutzung:
 *
 *   <FoundingBadge number={member.founding_number} />
 *   <FoundingBadge number={5} compact />   // kompakter Tag im Header-Row
 *   <FoundingBadge number={5} size="lg" /> // größer, Profilansicht
 */
export default function FoundingBadge({ number, compact = false, size = "md" }) {
  if (!number) return null;

  const base = "inline-flex items-center gap-1 font-outfit font-bold tracking-tight border";
  const scheme = "text-amber-300 border-amber-300/60 bg-gradient-to-r from-amber-300/20 via-amber-400/10 to-amber-300/20";

  const sizeClasses = {
    sm: "px-1.5 py-0.5 text-[9px]",
    md: "px-2 py-0.5 text-[10px]",
    lg: "px-2.5 py-1 text-[11px]",
  };
  const iconSize = size === "lg" ? 12 : size === "sm" ? 9 : 10;

  const label = compact ? `#${String(number).padStart(3, "0")}` : `Gründer · #${String(number).padStart(3, "0")}`;

  return (
    <span
      className={`${base} ${scheme} ${sizeClasses[size] || sizeClasses.md}`}
      title={`Gründungsmitglied #${number} — eines der ersten 50 Mitglieder`}
      data-testid="founding-badge"
    >
      <Crown size={iconSize} className="fill-amber-300/30" strokeWidth={2.2} />
      <span className="uppercase leading-none">{label}</span>
    </span>
  );
}
